module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content has-text-centered"
  }, [_vm._m(0), _vm._v(" "), _c('p', [_vm._v("Code licensed under "), _c('a', {
    attrs: {
      "href": 'https://github.com/' + _vm.repository + '/blob/master/LICENSE'
    }
  }, [_vm._v(_vm._s(_vm.license))]), _vm._v(".")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-code"
  })]), _vm._v(" with "), _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-heart"
  })]), _vm._v(" by "), _c('a', {
    attrs: {
      "href": "https://github.com/indevsDigital"
    }
  }, [_vm._v("Indevs Digital")]), _vm._v(".")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2436ebc0"}!./client/components/layout/footer/template.html
// module id = 223
// module chunks = 17